import AddressService from './services/addressService'
import { scrollUp } from './helpers'
import { validateRegisterForm } from './forms/validations'

let formMode = 'new'

export const initAddressForms = () => {
  $('.create_address').on('click', (event) => {
    formMode = 'new'
    $(event.target).hide()
    $('#customer-fields').addClass('show-customer-fields')
    $('#view_only_address_name').hide()
    $('#shipping-address-form').trigger('reset')
    $('#delete-address').hide()
    var html = `<input type='text' class='field' name='address_name' id='address-name' placeholder='登録名' required autocomplete="off"/><span id='view_only_address_name'></span>`
    $('.address_name_container').html(html)

    //attaching event listeners to newly created input
    $('#address-name').on('change', function () {
      const $this = $(this)
      if ($this.val() !== '') {
        $this.addClass('entered')
      } else {
        $this.removeClass('entered')
      }
    })

    $('#address-name').on('keydown paste', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

    return false
  })

  $('form#shipping-address-form').submit(async function (e) {
    e.preventDefault()
    $('.create_address').show()
    let previousErrors = $('.errors li')
    previousErrors.remove()
    let isValid = await validateRegisterForm()

    if (isValid) {
      let customer = {}
      customer.customer_id = globalThis.FFJP.userID
      customer.default = false
      customer.name = $('#address-name').val()
      customer.last_name = $('#register-last-name').val()
      customer.first_name = $('#register-first-name').val()
      customer.kana_last_name = $('#register-last-name2').val()
      customer.kana_first_name = $('#register-first-name2').val()
      customer.country = 'Japan'
      customer.country_code = 'JP'
      customer.zip = $('#register-post-code').val()
      customer.province = $('#register-place').val()
      customer.province_code =
        'JP-' +
        (
          '0' + globalThis.jpPrefecture.prefConvert(customer.province, 'id')
        ).slice(-2) //(0 + n).slice(-2) prefixes 0 for 1 digit numbers
      customer.city = $('#register-city').val()
      customer.address1 = $('#register-adress').val()
      customer.address2 = $('#register-number').val()
      customer.phone = $('#register-phone').val()
      customer.elevator = $("input[name='customer[elevator]']:checked").val()
      customer.floor = $('#register-level').val()
      customer.roomsize = $('#level-plan').val()
      customer.company = $('#register-firm').val()

      if (formMode == 'new') {
        AddressService.newAddress(customer).done((address) => {
          $('#customer-fields').removeClass('show-customer-fields')
          let addressHTML = ''
          if (window.location.href.includes('/account/addresses')) {
            addressHTML = `<div class="address" data-metafield="${JSON.stringify(
              address
            ).replace(/"/g, '&quot;')}" data-address_name="${address.name}">
            <span class="edit-address">編集</span>
            <label for="${address.name}">
             <span>${address.name} - ${address.province}${address.city}${
              address.address1
            } ${address.address2}</span>
             </label>
            </div>`
          } else {
            addressHTML = `<div class="address" data-metafield="${JSON.stringify(
              address
            ).replace(/"/g, '&quot;')}" data-address_name="${address.name}">
            <span class="edit-address">編集</span><label for="${address.name}">
            <input type="radio" name="selected_address" class="address_input" id="${
              address.name
            }"
              data-address_name="${
                address.name
              }" data-metafield="${JSON.stringify(address).replace(
              /"/g,
              '&quot;'
            )}"/>
             <span class="radio_value">${address.name} - ${address.province}${
              address.city
            }${address.address1} ${address.address2}</span></label>
          </div>`
          }

          $('.address_list').append(addressHTML)
          $('.address_list input').last().prop('checked', true)
          scrollUp($('.address_list'))

          $('.edit-address').off('click')
          initEditAddressButton()
        })
      } else {
        AddressService.editAddress(customer).done((newAddress) => {
          const $addressDiv = $(`div[data-address_name="${newAddress.name}"]`)
          $addressDiv.attr('data-metafield', JSON.stringify(newAddress))

          const $addressInput = $(
            `input[data-address_name="${newAddress.name}"]`
          )
          $addressInput.attr('data-metafield', JSON.stringify(newAddress))

          const newAddressInfoField = $addressInput.siblings('.radio_value')
          if (newAddressInfoField.length > 0) {
            newAddressInfoField.html(
              `${newAddress.name} - ${newAddress.province}${newAddress.city}${newAddress.address1} ${newAddress.address2}`
            )
          } else {
            $(`label[for='${newAddress.name}'] > span`).html(
              `${newAddress.name} - ${newAddress.province}${newAddress.city}${newAddress.address1} ${newAddress.address2}`
            )
          }

          $('#customer-fields').hide()
          scrollUp($('.address_list'))
        })
      }

      return true
    } else {
      $('form#shipping-address-form')[0].reportValidity()
      return false
    }
  })

  $('#delete-address').on('click', (e) => {
    if (!confirm('お届け先を削除します。よろしいですか？')) return
    let addressName = $(e.target).data('address_name')
    // eslint-disable-next-line no-unused-vars
    AddressService.deleteAddress(addressName).done((response) => {
      $(".address[data-address_name='" + addressName + "']").remove()
      $('#customer-fields').hide()
      scrollUp($('body'))
    })
  })

  initEditAddressButton()
}

const initEditAddressButton = () => {
  $('.edit-address').on('click', function (e) {
    e.preventDefault()
    formMode = 'edit'
    let addressMetafield = $(e.target).parent('div').attr('data-metafield')
    let address = JSON.parse(addressMetafield)

    $('#customer-fields').css('display', 'block')
    $('#delete-address').css('display', 'block')
    scrollUp($('#customer-fields'))

    $('#address-name').replaceWith(
      `<input type="hidden" class="field" name="address_name" id="address-name" placeholder="登録名" required autocomplete="off" value="${address.name}">`
    )
    $('#view_only_address_name').text(address.name)
    $('#register-last-name').val(address.last_name)
    $('#register-first-name').val(address.first_name)
    $('#register-last-name2').val(address.kana_last_name)
    $('#register-first-name2').val(address.kana_first_name)
    $('#register-post-code').val(address.zip)
    $('#register-place').val(address.province)
    $('#register-city').val(address.city)
    $('#register-adress').val(address.address1)
    $('#register-number').val(address.address2)
    $('#register-phone').val(address.phone)
    if (address.elevator) {
      $("input[name='customer[elevator]']#" + address.elevator).prop(
        'checked',
        true
      )
    } else {
      $("input[name='customer[elevator]']#なし").prop('checked', true)
    }

    $('#register-level').val(address.floor)
    $('#level-plan').val(address.roomsize)
    $('#register-firm').val(address.company)

    // to set the address_name for delete
    $('#delete-address').data('address_name', address.name)
  })
}
